import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";

export const changeDeliveryDriver = async (deliveryId, driverId, externalDriverData) => {
    const changeDriverRes = await HttpClient.put(
        `/api/deliveryProviders/deliveries/${deliveryId}/drivers/${driverId}`,
        {externalDriverData}
    );

    if (changeDriverRes.error) {
        message.error(new StringBuilder("שגיאה בעת שינוי נהג").append(`(${changeDriverRes.error})`).toString());
    } else {
        message.success("משלוח שונה בהצלחה");
    }

    return changeDriverRes;
};

export const changeDeliveryStatus = async (deliveryId, status) => {
    const changeDeliveryStatusRes = await HttpClient.put(`/api/deliveryProviders/deliveries/${deliveryId}/status`, {
        status
    });

    if (changeDeliveryStatusRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת שינוי סטטוס משלוח").append(`(${changeDeliveryStatusRes.error})`).toString()
        );
    } else {
        message.success("משלוח שונה בהצלחה");
    }

    return changeDeliveryStatusRes;
};

export const markDeliveryAsDelivered = async deliveryId => {
    const markDeliveryAsDeliveredRes = await HttpClient.put(
        `/api/deliveryProviders/deliveries/${deliveryId}/markAsDelivered`
    );

    if (markDeliveryAsDeliveredRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת סימון משלוח כסופק").append(`(${markDeliveryAsDeliveredRes.error})`).toString()
        );
    } else {
        message.success("משלוח סופק בהצלחה");
    }

    return markDeliveryAsDeliveredRes;
};

export const revertDeliveredStatus = async deliveryId => {
    const revertDeliveredStatusRes = await HttpClient.put(
        `/api/deliveryProviders/deliveries/${deliveryId}/revertDelivered`
    );

    if (revertDeliveredStatusRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת ביטול סימון משלוח כסופק")
                .append(`(${revertDeliveredStatusRes.error})`)
                .toString()
        );
    } else {
        message.success("ביטול סימון משלוח כסופק בוצע בהצלחה");
    }

    return revertDeliveredStatusRes;
};

export const changeDeliveryStatusToFailed = async (deliveryId, errorMessage) => {
    const changeDeliveryStatusRes = await HttpClient.put(
        `/api/deliveryProviders/deliveries/${deliveryId}/status/failed`,
        {errorMessage}
    );

    if (changeDeliveryStatusRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת שינוי סטטוס משלוח").append(`(${changeDeliveryStatusRes.error})`).toString()
        );
    } else {
        message.success("משלוח שונה בהצלחה");
    }

    return changeDeliveryStatusRes;
};

export const updateDeliveries = async deliveries => {
    const updateDeliveriesRes = await HttpClient.put(`/api/deliveryProviders/deliveries`, {
        deliveries
    });

    return updateDeliveriesRes;
};

export const addDeliveryStatusMessage = async (deliveryId, statusMessage) => {
    const addDeliveryStatusMessageRes = await HttpClient.post(
        `/api/deliveryProviders/deliveries/${deliveryId}/status-message`,
        {
            statusMessage
        }
    );

    return addDeliveryStatusMessageRes;
};

export const updateDeliveryBusinessSignature = async (deliveryId, businessSignature) => {
    const updateDeliveryBusinessSignatureRes = await HttpClient.put(
        `/api/deliveryProviders/deliveries/${deliveryId}/businessSignature`,
        {
            businessSignature
        }
    );

    if (updateDeliveryBusinessSignatureRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת עדכון חתימה")
                .append(`(${updateDeliveryBusinessSignatureRes.error})`)
                .toString()
        );
    }

    return updateDeliveryBusinessSignatureRes;
};
